import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import type { BreadcrumbItem } from '@/components/base/Breadcrumb';

const FORM_URL = 'https://readdy.ai/api/form/d9u4hp53pcjqs2fcsm2g';

export default function AboutPage() {
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!FORM_URL) return;

    setSubmitting(true);
    setFormError('');
    setFormSuccess(false);

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormSuccess(true);
      form.reset();
      setSubmitting(false);
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');

      const resp = await fetch(FORM_URL, {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const responseText = await resp.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* raw text */ }

      if (resp.ok && (parsed as { code?: string })?.code === 'OK') {
        setFormSuccess(true);
        form.reset();
      } else {
        const serverMsg =
          (parsed as { meta?: { message?: string } })?.meta?.message ||
          (parsed as { message?: string })?.message ||
          (parsed as { meta?: { detail?: string } })?.meta?.detail ||
          responseText;
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setFormError('提交失败，请稍后再试。');
        } else {
          setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试。');
        }
      }
    } catch {
      setFormError('网络错误，请稍后再试。');
    } finally {
      setSubmitting(false);
    }
  };

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        name: '关于我们 - 乳交完全指南',
        description: '乳交完全指南的品牌介绍、口碑与联系方式',
        url: 'https://milkguide.github.io/about',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'Organization',
        name: '乳交完全指南',
        url: 'https://milkguide.github.io/',
        description: '致力于为成年伴侣提供专业、负责任的亲密关系教育内容。',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="px-4 md:px-6 py-6 md:py-8 max-w-4xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />

            {/* Page Header */}
            <section className="mb-10">
              <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
                关于我们
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl leading-relaxed">
                乳交完全指南是一个专注于成人亲密关系教育的知识平台，致力于为成年伴侣提供科学、专业、负责任的亲密关系知识与指导。
              </p>
            </section>

            {/* Brand Introduction */}
            <section className="mb-10">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                品牌介绍
              </h2>
              <div className="bg-background-100 rounded-lg p-5 md:p-6">
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  乳交完全指南成立于2024年，由一群关注成人健康与亲密关系教育的专业人士共同发起。我们深知，在华人文化环境中，关于亲密关系和性教育的话题常常被忽视或回避，导致许多成年伴侣在探索亲密关系时缺乏可靠的知识来源。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  我们的使命是打破沉默与偏见，以严谨、负责任、非色情化的方式，向成年伴侣提供关于乳交及其他亲密行为的专业知识。我们相信，良好的亲密关系建立在充分的知识、真诚的沟通和相互尊重的基础上。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  所有文章均由具有医学、心理学或性教育背景的专业人士参与审核，确保内容的准确性、安全性和教育价值。我们始终坚持"安全第一、尊重至上、双向愉悦"的核心价值观。
                </p>
              </div>
            </section>

            {/* Core Values */}
            <section className="mb-10">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
                核心价值观
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                    <i className="ri-heart-line text-accent-600"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                    尊重至上
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    尊重每个人的身体自主权和选择权，强调知情同意的核心地位。
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                    <i className="ri-shield-check-line text-primary-600"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                    安全第一
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    所有内容以安全为首要原则，强调卫生、适度与健康风险防范。
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                    <i className="ri-chat-smile-2-line text-secondary-600"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                    双向愉悦
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    倡导伴侣间的双向关怀与共同享受，而非单方面的满足。
                  </p>
                </div>
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-10">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                    "内容非常专业且尊重读者。作为一对想尝试新鲜事物的伴侣，我们在这里找到了需要的知识，而且文风让人感觉很舒服。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 匿名用户 · 恋爱3年</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                    "特别喜欢关于沟通和知情同意的内容。这让我意识到，提升亲密关系的关键不在于技巧本身，而在于彼此的尊重和理解。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 匿名用户 · 已婚1年</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                    "覆盖面很全，从基础到进阶都有。作为新手，感觉很受用。最重要的是强调安全，这点比什么都重要。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 匿名用户 · 恋爱半年</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                    "网站设计简洁大方，没有低俗感。这点很加分。内容质量也超出了预期，值得推荐给身边的朋友。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 匿名用户 · 已婚3年</p>
                </div>
              </div>
            </section>

            {/* Contact Form */}
            <section className="mb-10">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
                联系我们
              </h2>
              <div className="bg-background-100 rounded-lg p-5 md:p-6">
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                  如果您有任何疑问、建议或合作意向，欢迎通过以下表单与我们取得联系。我们会在48小时内回复。
                </p>

                {FORM_URL ? (
                  <form
                    onSubmit={handleSubmit}
                    data-readdy-form
                    id="contact-form"
                    className="space-y-4"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="name" className="block text-sm text-foreground-700 mb-1">
                          姓名 <span className="text-accent-600">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm text-foreground-700 mb-1">
                          邮箱 <span className="text-accent-600">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                    </div>

                    <div>
                      <label htmlFor="subject" className="block text-sm text-foreground-700 mb-1">
                        主题
                      </label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                        placeholder="请输入主题"
                      />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm text-foreground-700 mb-1">
                        留言内容 <span className="text-accent-600">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        maxLength={500}
                        rows={5}
                        className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                        placeholder="请输入您的留言（不超过500字）"
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                    </div>

                    {/* Honeypot */}
                    <input
                      type="text"
                      name="website_alt"
                      className="form-hp-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />

                    {formError && (
                      <p className="text-sm text-accent-600">{formError}</p>
                    )}
                    {formSuccess && (
                      <p className="text-sm text-secondary-700">提交成功！我们会尽快回复您。</p>
                    )}

                    <button
                      type="submit"
                      disabled={submitting}
                      className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {submitting ? (
                        <>
                          <i className="ri-loader-4-line animate-spin"></i> 提交中...
                        </>
                      ) : (
                        <>
                          <i className="ri-send-plane-line"></i> 提交留言
                        </>
                      )}
                    </button>
                  </form>
                ) : (
                  <p className="text-sm text-foreground-500">表单加载中...</p>
                )}
              </div>
            </section>

            {/* Disclaimer */}
            <section className="bg-accent-50 border border-accent-200 rounded-lg p-5">
              <h3 className="font-heading text-sm font-semibold text-accent-800 mb-2">
                <i className="ri-alert-line mr-1"></i> 免责声明
              </h3>
              <p className="text-xs text-accent-700 leading-relaxed">
                本网站所有内容仅供18岁以上成年人参考，旨在提供教育信息，不构成医疗或心理咨询建议。如有任何健康或关系方面的疑虑，请咨询具有执业资格的专业医师或心理咨询师。本网站对用户基于本站内容所做出的任何决定或行为不承担法律责任。
              </p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}